export default "__VITE_ASSET__CMnuQUgt__"